import { Checkbox, Link, ModalWindow, TextInput } from "@tblabs/truffle";
import { Icons } from "../Components/Utils/Icons";
import { XPrimaryButton } from "../Components/Utils/XPrimaryButton";
import { AgentsProvider } from "../Services/Agents/AgentsProvider";
import { Router } from "../Services/Router";
import { Page } from "./Page";
import { TableViewer } from "../Components/TableViewer";


export class AgentsPage extends Page
{
    constructor(private _router: Router, private _agents: AgentsProvider)
    {
        super("Agenci");

        this.Content(async (body) =>
        {
            body.Append(
                new TableViewer(this._agents.All).TextAlignLeft()
                    // .AddColumn("Imię", x => `${x.Icon} ${x.Name} (${x.Phone})`)
                    // .AddColumn("Stan", x => x.IsActive ? "✅ Aktywny" : "🔴 Nieaktywny")
                    // .AddColumn("", x => new XPrimaryButton("Zadania", Icons.Calendar, () => this._router.GoToAgentTasks(x.Id)))
                    // .AddColumn("", x => new Link("😴 Dezaktywuj").OnClick(() => x.IsActive = false))
                    .AddColumn("Id", x => x.Id.value)
                    .AddColumn("Icon", x => new TextInput(x.Icon))
                    .AddColumn("Name", x => new TextInput(x.Name))
                    .AddColumn("Phone", x => new TextInput(x.Phone))
                    .AddColumn("IsActive", x => new Checkbox(x.IsActive))
                    .AddColumn("", x => new XPrimaryButton("Zapisz", Icons.Save, async () => await this._agents.Save(x)))
                    // .AddColumn("", x => new XPrimaryButton("Zadania", Icons.Calendar, () => this._router.GoToAgentTasks(x.Id)))
                    .Build(),
                new XPrimaryButton("Dodaj agenta", Icons.Plus, async () => await this._agents.Add()),
            );
        });
    }
}
